/**
 * @returns distance between two coordinates, in miles
 * @see https://github.com/yousufkalim/nearby-sort for the original implementation.
 */
export function getDistance(
  lat1?: number,
  lon1?: number,
  lat2?: number,
  lon2?: number
): number {
  if (!lat1 || !lon1 || !lat2 || !lon2) return NaN;
  const R = 3958.8; // Radius of the earth in miles
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in miles
  return d;
}

// Degree conversion
const deg2rad = (deg: number): number => {
  return deg * (Math.PI / 180);
};
